import React from "react";

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="440"
      height="200"
      version="1"
      viewBox="0 0 330 150"
    >
      <path
        fill="var(--green-color)"
        d="M250 1085v-25h2740v50H250v-25zM461 1039c-125-24-212-133-211-263 1-123 77-219 200-252 42-12 38-13-77-13l-123-1v-50h2740v50H1768c-1200 1-1222 1-1170 19 61 21 123 76 155 136 25 48 30 161 8 213l-13 32H520V800h162l-7-37c-16-89-76-143-157-143-57 0-96 17-131 60-72 85-29 224 79 252l44 12v53c0 29-1 53-2 52-2-1-23-5-47-10z"
        transform="matrix(.1 0 0 -.1 0 150)"
      ></path>
      <path
        fill="var(--green-color)"
        d="M1057 956c-46-17-64-32-83-67-33-65-6-152 58-185 91-47 198 7 215 109l6 37h-72c-64 0-71-2-71-20 0-17 7-20 50-20 29 0 50-5 50-11 0-40-56-79-114-79-25 0-45 9-68 29-28 25-33 36-33 76s5 51 33 76c35 31 94 39 134 18 31-17 46 5 17 24-37 23-80 28-122 13zM1730 825c0-138 1-145 20-145 14 0 20 7 20 22 0 20 1 20 19 4 11-10 36-18 56-19 79-2 120 102 63 160-31 30-89 34-119 7-19-17-19-16-19 49 0 60-2 67-20 67-19 0-20-7-20-145zm154-1c20-20 21-78 0-94-21-18-72-17-91 3-20 19-21 70-3 91 16 21 74 20 94 0zM2800 825c0-122 2-145 15-145s15 23 15 145-2 145-15 145-15-23-15-145zM2304 945c-9-23 10-40 25-22 9 11 8 17-4 27s-16 9-21-5zM1453 873c-59-11-84-108-40-158 28-33 87-37 118-9 19 17 20 17 26-4 3-12 12-22 19-22 11 0 14 22 14 100 0 82-3 100-15 100-8 0-15-9-15-20 0-24-8-25-29-6-20 17-49 24-78 19zm81-55c23-32 20-55-10-84-19-20-31-24-52-19-78 18-66 125 14 125 23 0 38-7 48-22zM2080 780c0-81 3-100 15-100 11 0 15 17 17 73 3 64 6 73 26 82 12 5 22 18 22 27 0 15-4 16-25 8-16-6-25-6-25 0s-7 10-15 10c-12 0-15-18-15-100zM2300 780c0-82 3-100 15-100s15 18 15 100-3 100-15 100-15-18-15-100zM2553 873c-31-6-73-59-73-93 0-36 41-86 76-93 34-6 86 11 81 27-2 6-20 10-45 8-23-2-42 0-42 5s23 31 50 58c28 27 50 52 50 56 0 6-64 40-72 38-1-1-13-4-25-6zm17-78c-43-44-60-49-60-17 0 35 29 62 68 62h36l-44-45z"
        transform="matrix(.1 0 0 -.1 0 150)"
      ></path>
    </svg>
  );
}

export default Logo;
